module.exports = __webpack_public_path__ + "static/media/bg30.467de900.jpg";